import axios from "axios";
export default {
    AUTH_REQUEST({ commit, dispatch }, user) {
        return new Promise((resolve, reject) => {
            //const token = new Date();
            // The Promise used for router redirect in login
            commit("AUTH_REQUEST");

            const baseUrl = window.location.origin.startsWith(
                "http://localhost:8080",
            )
                ? "https://localhost:44307"
                : window.location.origin;

            const url = user.windowsLogin
                ? baseUrl + "/api/login/windowsLogin?"
                : baseUrl + "/api/login/login?";

            axios
                .post(url, {
                    username: user.username,
                    password: user.password,
                })
                .then((resp) => {
                    const response = resp.data;

                    const token = "Bearer " + response.token;

                    localStorage.setItem("user-token", token); // store the token in localstorage
                    localStorage.setItem("user-isAdmin", response.isAdmin); // store the role in localstorage
                    localStorage.setItem("user-name", user.username); // store the role in localstorage
                    localStorage.setItem("user-email", response.emailAddress);
                    localStorage.setItem("user-uta-phone", response.utaPhone);
                    localStorage.setItem("branch", response.branch);
                    localStorage.setItem("user-roles", response.roles);
                    localStorage.setItem(
                        "user-plivo-phone",
                        response.plivoPhone,
                    );

                    const claims = response.claims;

                    if (response.plivoPhone) {
                        claims.push("Phone Detail");
                    }

                    localStorage.setItem("user-claims", claims);

                    commit("AUTH_SUCCESS", {
                        token: token,
                        user: user.username,
                        claims: response.claims,
                        roles: response.roles,
                        isAdmin: response.isAdmin,
                        utaPhone: response.utaPhone,
                        plivoPhone: response.plivoPhone,
                        emailAddress: response.emailAddress,
                        branch: response.branch,
                    });

                    resolve(response);
                })
                .catch((err) => {
                    commit("AUTH_ERROR", err);
                    localStorage.removeItem("user-token");

                    let errorMessage = err;

                    if (err.response.data && err.response.data.Message) {
                        errorMessage = err.response.data.Message;
                    }

                    reject(errorMessage);
                });
        });
    },
    AUTH_LOGOUT({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            //commit('AUTH_LOGOUT')
            localStorage.removeItem("user-token");
            localStorage.removeItem("user-claims");
            localStorage.removeItem("user-roles");
            localStorage.removeItem("user-isAdmin");
            localStorage.removeItem("user-name");
            localStorage.removeItem("user-email");
            localStorage.removeItem("user-uta-phone");
            localStorage.removeItem("user-plivo-phone");
            localStorage.removeItem("branch");

            commit("AUTH_LOGOUT");

            resolve();
        });
    },
    CLAIMS({ commit, dispatch }, claims) {
        commit("CLAIMS", claims);
    },
};
